import { render } from "./TableNoteField.vue?vue&type=template&id=e81bac56"
import script from "./TableNoteField.vue?vue&type=script&lang=js"
export * from "./TableNoteField.vue?vue&type=script&lang=js"

import "./TableNoteField.vue?vue&type=style&index=0&id=e81bac56&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__